import React from "react"
import styled from "styled-components"
import Project from "./project"

// import dashMP4 from "../images/projects_v/dash.mp4"
// import ocrMP4 from "../images/projects_v/ocr.mp4"
// import qMP4 from "../images/projects_v/playground_1.mp4"
import qwebm from "../images/projects_v/playground.webm"
import dashwebm from "../images/projects_v/dash.webm"
import ocrwebm from "../images/projects_v/ocr.webm"
import linkedinwebm from "../images/projects_v/linkedin.webm"

const StyledWork = styled.section`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background: #1a1a1a;
  padding: 100px 0;

  .work {
    &__wrapper {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 60px 30px;
      width: 80%;
    }
    &__box {
      video {
        width: 100%;
        opacity: 1;
        transition: 0.5s;
        border-radius: 4px;
        box-shadow: 0px 0px 10px black;
      }

      a {
        margin-right: 10px;
      }

      svg {
        width: 20px;
        height: 20px;
        transition: 0.2s;
        filter: drop-shadow(0px 0px 3px black);
        opacity: 1;

        &:hover {
          color:  #f05637;
          transition: 0.2s;
        }
      }

      &:hover {
        span,
        svg,
        video {
          opacity: 0.5;
          transition: 0.2s;
        }
      }
    }
    &__links {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 10px;

      span {
        font-size: 14px;
        text-shadow: 0px 0px 10px black;
        opacity: 0.4;
        transition: 0.2s;
      }
    }
    &__desc {
      text-align: center;
      margin: 50px 0;
      color: #bdbdbd;
    }
    &--animation {
      

    }
  }
`

export default function Work() {
  return (
    <StyledWork id="projects">
      <div className="container container--secondary">
        
      </div>
    </StyledWork>
  )
}
